import React, { Component } from 'react';
import QuickSearchResult from './QuickSearchResult';
import { translate } from '../Services/translation';

class QuickSearch extends Component {
    focusOnInput() {
        setTimeout(() => {
            this.searchInput && this.searchInput.focus();
        }, 0);
    }
    
    render () {
        const { query, result, showResult, onSearch, onBlur, onKeyDown, selectedItem, searchUrl } = this.props;
        return (
            <div className="quick-search" role="search">
                <div className={`quick-search__form quick-search__form--force-show`} role="search">
                    <input className="quick-search__input" type="search" placeholder={translate('general.search')}
                        autoComplete="off" value={decodeURIComponent(query)} onChange={event => onSearch(encodeURIComponent(event.target.value))}
                        onKeyDown={event => onKeyDown(event, {searchUrl})} ref={(input) => { this.searchInput = input; }}
                        onBlur={() => onBlur() }/>
                    <button className="quick-search__submit-button" type="submit">
                        <span className="quick-search__submit-title"></span>
                    </button>
                    <i className="fal fa-search"></i>
                    {showResult && <QuickSearchResult result={result} selectedItem={selectedItem} searchUrl={searchUrl}/>}
                </div>
            </div>
        )
    }
}

export default QuickSearch;